module.exports = __webpack_public_path__ + "static/media/iconChallengeActive.f5ed57b2.svg";